<fury-list>
  <div class="table table_container">
    <table mat-table [dataSource]="dataSource">
      <!--- Note that these columns can be defined in any order.
                  The actual rendered columns are set as a property on the row definition" -->

      <!-- Leads Status Column -->
      <ng-container matColumnDef="vanillaSoftStatus">
        <th mat-header-cell *matHeaderCellDef>Leads Status</th>
        <td mat-cell *matCellDef="let element">
          {{ element?.vanillaSoftStatus }}
        </td>
      </ng-container>

      <!-- Assigned User Column -->
      <ng-container matColumnDef="consumer">
        <th mat-header-cell *matHeaderCellDef>Assigned User</th>
        <td mat-cell *matCellDef="let element">
          {{
            commonService.getFullName(
              element?.consumer?.firstName,
              element?.consumer?.lastName
            )
          }}
        </td>
      </ng-container>

      <!-- Last Result Column -->
      <ng-container matColumnDef="resultCode">
        <th mat-header-cell *matHeaderCellDef>Last Result</th>
        <td mat-cell *matCellDef="let element">
          {{ element?.resultCode }}
        </td>
      </ng-container>

      <!-- Result Count Column -->
      <ng-container matColumnDef="attempts">
        <th mat-header-cell *matHeaderCellDef>Result Count</th>
        <td mat-cell *matCellDef="let element">
          {{ element?.attempts }}
        </td>
      </ng-container>

      <!-- Created on Column -->
      <ng-container matColumnDef="addedOn">
        <th mat-header-cell *matHeaderCellDef>Created On</th>
        <td mat-cell *matCellDef="let element">
          {{ commonService.convertDate( element?.addedOn) | date : "MMM-dd-YYYY h:mm a" }}
        </td>
      </ng-container>

      <!-- Created By Column -->
      <ng-container matColumnDef="lastAgentName">
        <th mat-header-cell *matHeaderCellDef>Created By</th>
        <td mat-cell *matCellDef="let element">{{ element?.createdBy }}</td>
      </ng-container>

      <!--  IP Address Column -->
      <ng-container matColumnDef="submission">
        <th mat-header-cell *matHeaderCellDef>IP Address</th>
        <td mat-cell *matCellDef="let element">
          {{ element?.ipAddress }}
        </td>
      </ng-container>

      <!-- First name Column -->
      <ng-container matColumnDef="firstName">
        <th mat-header-cell *matHeaderCellDef>First Name</th>
        <td mat-cell *matCellDef="let element">{{ element?.firstName }}</td>
      </ng-container>

      <!-- Last Name Column -->
      <ng-container matColumnDef="lastName">
        <th mat-header-cell *matHeaderCellDef>Last Name</th>
        <td mat-cell *matCellDef="let element">
          {{ element?.lastName }}
        </td>
      </ng-container>

      <!-- Address Column -->
      <ng-container matColumnDef="streetAddress">
        <th mat-header-cell *matHeaderCellDef>Address</th>
        <td mat-cell *matCellDef="let element">
          {{ element?.address?.streetAddress }}
        </td>
      </ng-container>

      <!-- City Column -->
      <ng-container matColumnDef="city">
        <th mat-header-cell *matHeaderCellDef>City</th>
        <td mat-cell *matCellDef="let element">
          {{ element?.address?.city }}
        </td>
      </ng-container>

      <!-- State Column -->
      <ng-container matColumnDef="state">
        <th mat-header-cell *matHeaderCellDef>State</th>
        <td mat-cell *matCellDef="let element">{{ element?.stateName }}</td>
      </ng-container>

      <!-- Zip Code Column -->
      <ng-container matColumnDef="zip">
        <th mat-header-cell *matHeaderCellDef>Zip Code</th>
        <td mat-cell *matCellDef="let element">
          {{ element?.address?.zip }}
        </td>
      </ng-container>

      <!-- Phone Column -->
      <ng-container matColumnDef="mobileNumber">
        <th mat-header-cell *matHeaderCellDef>Phone</th>
        <td mat-cell *matCellDef="let element">
          {{ element?.mobileNumber | mask: '(000) 000-0000' }}
        </td>
      </ng-container>

      <!-- Email Column -->
      <ng-container matColumnDef="emailAddress">
        <th mat-header-cell *matHeaderCellDef>Email</th>
        <td mat-cell *matCellDef="let element">
          {{ element?.emailAddress }}
        </td>
      </ng-container>

      <!-- Notes Column -->
      <ng-container matColumnDef="notes">
        <th mat-header-cell *matHeaderCellDef>Notes</th>
        <td mat-cell *matCellDef="let element">
          <div class="maxTxt">
            {{ element?.notes }}
          </div>
          
        </td>
      </ng-container>
      <ng-container matColumnDef="leadAction" stickyEnd>
        <th mat-header-cell *matHeaderCellDef>Checkout<th>
        <td mat-cell *matCellDef="let element"><span style="cursor: pointer;" (click)="handleCheckout(element)"><mat-icon>open_in_new</mat-icon></span></td>
      </ng-container>

      <ng-container matColumnDef="actions" stickyEnd>
        <th *matHeaderCellDef class="actions-cell" mat-header-cell>Actions</th>
        <td *matCellDef="let row; let i = index" class="actions-cell" mat-cell>
          <button
            type="button"
            mat-icon-button
            [matMenuTriggerFor]="actionsMenu"
            (click)="$event.stopPropagation()"
          >
            <mat-icon>more_horiz</mat-icon>
          </button>
          <mat-menu #actionsMenu="matMenu" yPosition="below" xPosition="before">
            <button mat-menu-item *ngIf="editorAccess" (click)="navigteDetailsPage(row)">
              <span>View</span>
            </button>
            <button mat-menu-item (click)="handleCheckout(row)" *ngIf="editorAccess && !row?.isCheckedOut && row?.isCoveredState">
              <span>Checkout</span>
            </button>
          </mat-menu>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    </table>
    <div
      *ngIf="!dataSource?.length"
      style="padding: 10px 0; text-align: center"
    >
      No data found.
    </div>
  </div>
</fury-list>
